/**
 * 基本設計のページの URL に書かれたチケット番号を、API が受ける形（大文字）にする。
 *
 * Backlog の課題キーは大文字だが、人が URL を手で打つと小文字になりやすい。小文字のまま
 * API に渡すと「そのチケットは無い」になるので、ページを出す前に大文字の URL へ送り直す。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 基本設計ページの URL のチケット番号を大文字の正規の形にし、送り直しが要るかを決める
 * @graph-connects none
 */
export function canonicalBdKey(bdKey: string): string | null {
  const upper = bdKey.trim().toUpperCase();
  return upper === bdKey ? null : upper;
}
